import { Heading, Stack, styled } from 'canoe';
import React from 'react';

interface WizardViewProps {
  children: React.ReactNode;
  title: string;
  subTitle?: string;
}

const Container = styled.div`
  max-width: 750px;
  margin: auto;
`;

const FormContainer = styled.div`
  max-width: 588px;
  margin: auto;
`;

export const WizardView = React.memo(({ title, subTitle, children }: WizardViewProps) => (
  <Container>
    <Stack justify="center" spaceAfter="xs">
      <Heading fullWidth size="S" element="h2" m="xxs" align="center">
        {title}
      </Heading>
      {subTitle && (
        <Heading fullWidth size="XXS" element="h4" m="xxs" align="center">
          {subTitle}
        </Heading>
      )}
    </Stack>
    <FormContainer>{children}</FormContainer>
  </Container>
));
